import React, { useState } from 'react';
import styled from '@emotion/styled';
import { colors, device } from './GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { Button } from './StyledComponents';
import { SlantedPicture } from '../SlantedPicture';

const StyledAppointment = styled.div`
    background: ${colors.white};
    .text-container {
        padding: 1em 0.75em;
    }
    .main-image {
        height: 450px;
    }
    h4 {
        width: 75%;
    }
    form {
        margin-top: 0.5em;
        .item {
            display: flex;
            flex-direction: column;
        }
        label {
            font-size: 14px;
        }
        button {
            margin-top: 1em;
            width: 100%;
        }
        .buttons {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        input,
        select {
            text-indent: 12px;
            margin: 1em 0em;
            padding: 1em 0.25em;
            background: #f9f9f9;
            border: 1px solid #e6e6e6;
            box-sizing: border-box;
            border-radius: 5px;
        }
    }
    @media ${device.tablet} {
        padding: 4em;
        form {
            .buttons {
                flex-direction: row;
                justify-content: center;
                button {
                    margin: 2em 1em 0em;
                    width: 45%;
                }
            }
        }
        .text-container {
            display: flex;
            flex-direction: column;
            margin-bottom: 4em;
            justify-content: center;
        }

        h4 {
            min-width: 400px;
            padding-left: 0.25em;
            line-height: 65px;
            font-size: 50px;
        }
        .main-image {
            border-radius: 24px;
            margin-bottom: 2em;
        }
    }
    @media ${device.laptop} {
        display: flex;
        padding: 0em;
        form {
            .buttons {
                button {
                    padding: 1em 0.75em;
                    margin: 0.25em 0.5em 0em;
                    width: 50%;
                }
            }
        }
        .main-image {
            height: 680px;
            border-radius: 0;
            margin-bottom: 0em;
        }

        .text-container {
            h4 {
                margin-bottom: 0.5em;
            }
            min-width: 40%;
        }
    }
    @media ${device.laptopL} {
        .text-container {
            h4 {
                padding-left: 0.5em;
            }
        }
        form {
            .buttons {
                button {
                    margin: 1em 0.5em 0em;
                    width: 45%;
                }
            }
        }
    }
    @media ${device.desktop} {
        .text-container {
            h4 {
                padding-left: 2em;
                max-width: 500px;
            }
        }
        form {
            .buttons {
                button {
                    margin: 1em 1em 0em;
                    width: 35%;
                }
            }
        }
    }
`;

export const AppointmentTwo: React.FC = () => {
    const [submitState, setSubmitState] = useState<string>();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSubmit = async (e: any) => {
        e.preventDefault();
        setSubmitState('submitting');
        setSubmitState('submitted');

        e.target.reset();
    };

    return (
        <StyledAppointment>
            <StaticImage
                className="main-image"
                src="../../images/shaking-hands.jpg"
                placeholder="none"
                alt="dentist shaking patient hands"
            />
            <div className="text-container">
                <h4>Book An Appointment</h4>
                <form onSubmit={onSubmit}>
                    <div className="buttons">
                        <Button color="blue" type="submit">
                            <a
                                target="_blank"
                                style={{ color: `${colors.white}` }}
                                rel="noreferrer"
                                href="https://www.flexbook.me/smilecraft/1"
                            >
                                Schedule Your Time
                            </a>
                        </Button>
                        <Button color="gold">
                            <a style={{ color: `${colors.gold}` }} href="tel:8132354143">
                                Call us Instead
                            </a>
                        </Button>
                    </div>
                </form>
            </div>
        </StyledAppointment>
    );
};
